import { SmartRenderer } from '@fusioncharts/core/src/component-interface';
import { parseColor, getSuggestiveRotation, isIpad, parseTooltext, BLANKSTRING } from '@fusioncharts/core/src/lib';

const START = 'start',
  END = 'end',
  INSIDE = 'inside',
  MIDDLE = 'middle',
  defaultTransform = 't0,0',
  // CENTER = 'center',
  SMALLSQUARE = '&#9632;',
  MEDIUMSQUARE = '&#x25FC;',
  getTooltext = (config, node, chartConfig) => {
    let uniChar = isIpad ? SMALLSQUARE : MEDIUMSQUARE,
      macroIndices = [3, 133, 134, 143, 144, 145],
      manager = node.getLinkedParent(),
      legend = node.getFromEnv('legend'),
      pathArr,
      drawCustomLegendIcon = chartConfig && chartConfig.drawcustomlegendicon,
      newPathArr = [],
      i,
      j,
      symbolBBox,
      plotToolText,
      legendItemSymbol,
      pathStart = [],
      finalPath,
      legendItem = (drawCustomLegendIcon && legend && legend.config && legend.config.isActive) ? legend.getItem(manager.config.legendItemMap[node.config.label]) : null,
      graphicalElement = legendItem && legendItem.getGraphicalElement(),
      parserConfig,
      toolText;
    finalPath = BLANKSTRING;
    if (legendItem) {
      legendItemSymbol = graphicalElement && graphicalElement.legendItemSymbol;
      pathArr = legendItemSymbol && legendItemSymbol.attrs.path.split(/(?=[LMCA])/);
      symbolBBox = legendItemSymbol && legendItemSymbol.node.getBBox();
      if (pathArr && pathArr.length) {
        for (i = 0; i < pathArr.length; i++) {
          pathStart.push(pathArr[i][0]);
          pathArr[i] = pathArr[i].substring(1, pathArr[i].length);
          if (i === (pathArr.length - 1)) {
            pathArr[i] = pathArr[i].substring(0, pathArr[i].length - 1);
          }
          newPathArr[i] = pathArr[i].split(',');
        }
      }
      if (newPathArr && newPathArr.length) {
        for (i = 0; i < newPathArr.length; i++) {
          if (newPathArr[i].length) {
            for (j = 0; j < newPathArr[i].length; j++) {
              newPathArr[i][j] = Number(newPathArr[i][j]);
              if (pathStart[i] !== 'A') {
                if (j === 0) {
                  newPathArr[i][j] = newPathArr[i][j] - (symbolBBox.x);
                } else if (j === 1) {
                  newPathArr[i][j] = newPathArr[i][j] - (symbolBBox.y);
                }
              } else if (pathStart[i] === 'A') {
                if (j === 5) {
                  newPathArr[i][j] = newPathArr[i][j] - (symbolBBox.x);
                } else if (j === 6) {
                  newPathArr[i][j] = newPathArr[i][j] - (symbolBBox.y);
                }
              }
            }
          }
          finalPath += pathStart[i] + newPathArr[i].toString();
        }
      }
      finalPath = finalPath + 'Z';
    }

    parserConfig = {
      label: config.label,
      value: config.value,
      nodeValue: config.props.value,
      nodeDataValue: config.value,
      plotFillColor: config.rawCosmetics && ('#' + config.rawCosmetics.fill),
      plotFillAlpha: config.rawCosmetics && config.rawCosmetics.alpha,
      plotIdentifier: legendItem ? `<svg height= ${symbolBBox.height} width = ${symbolBBox.width} overflow='visible' xmlns="http://www.w3.org/2000/svg">
      <path d= ${finalPath} fill = ${graphicalElement.legendItemSymbol.node.getAttribute('fill')} stroke = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke')}
      stroke-opacity = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke-opacity')} fill-opacity = ${graphicalElement.legendItemSymbol.node.getAttribute('fill-opacity')} 
      stroke-width = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke-width')} stroke-linecap = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke-linecap')}></path>
    </svg>` : `<span style='color: ${parseColor(config.rawCosmetics.fill)};'>${uniChar}&nbsp;</span>`
    };

    toolText = parseTooltext(config.toolText, macroIndices,
      parserConfig, { value: config.value,
        nodeValue: config.props.value,
        nodeDataValue: config.value,
        plotFillColor: config.rawCosmetics && ('#' + config.rawCosmetics.fill),
        plotFillAlpha: config.rawCosmetics && config.rawCosmetics.alpha,
        plotIdentifier: legendItem ? `<svg height= ${symbolBBox.height} width = ${symbolBBox.width} overflow='visible' xmlns="http://www.w3.org/2000/svg">
        <path d= ${finalPath} fill = ${graphicalElement.legendItemSymbol.node.getAttribute('fill')} stroke = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke')}
        stroke-opacity = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke-opacity')} fill-opacity = ${graphicalElement.legendItemSymbol.node.getAttribute('fill-opacity')} 
        stroke-width = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke-width')} stroke-linecap = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke-linecap')}></path>
      </svg>` : `<span style='color: ${parseColor(config.rawCosmetics.fill)};'>${uniChar}&nbsp;</span>` });

    plotToolText = parseTooltext(config.plotToolText,
      macroIndices,
      parserConfig, { value: config.value,
        nodeValue: config.props.value,
        nodeDataValue: config.value,
        plotFillColor: config.rawCosmetics && ('#' + config.rawCosmetics.fill),
        plotFillAlpha: config.rawCosmetics && config.rawCosmetics.alpha,
        plotIdentifier: legendItem ? `<svg height= ${symbolBBox.height} width = ${symbolBBox.width} overflow='visible' xmlns="http://www.w3.org/2000/svg">
        <path d= ${finalPath} fill = ${graphicalElement.legendItemSymbol.node.getAttribute('fill')} stroke = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke')}
        stroke-opacity = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke-opacity')} fill-opacity = ${graphicalElement.legendItemSymbol.node.getAttribute('fill-opacity')} 
        stroke-width = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke-width')} stroke-linecap = ${graphicalElement.legendItemSymbol.node.getAttribute('stroke-linecap')}></path>
      </svg>` : `<span style='color: ${parseColor(config.rawCosmetics.fill)};'>${uniChar}&nbsp;</span>` });

    config.setToolText = toolText;
    config.setPlotTooltext = config.setToolText ? config.setToolText : plotToolText;
    if (!config.plotToolText) {
      return (
        `<div style='padding: 2px; vertical-align: middle;'>
          <span style='color: ${parseColor(config.rawCosmetics.fill)};'>${uniChar}&nbsp;</span>${config.label}
          &nbsp;
          &nbsp;
          ${config.value}
        </div>`
      );
    }

    return (
      `<div style='padding: 2px; vertical-align: middle;'>
        <span style='color: ${parseColor(config.rawCosmetics.fill)};'>${uniChar}&nbsp;</span>
        ${config.setPlotTooltext}
      </div>`
    );
  },
  // GUTTER5 = 5,
  BLANK = '',
  SPACE = ' ';
class SankeyNode extends SmartRenderer {
  getType () {
    return 'node';
  }

  getName () {
    return 'sankey-node';
  }

  configureAttributes (inputConfig = {}) {
    let nodeConfig = this.config;

    Object.assign(nodeConfig, inputConfig);
  }

  allocatePosition () {
    let node = this,
      { props, style, mode, labelPosition, showLabel,
        formattedLabel, showValue, value, rotateLabel, labelPadding } = node.config,
      nodeCosmetics = style.node[mode],
      labelCosmetics = style.label[mode],
      orientation = node.getFromEnv('orientation'),
      sl = node.getFromEnv('smartLabel'),
      labelXPos,
      labelYPos,
      anchor,
      labelSepChar = node.getLinkedParent().config.labelSepChar,
      text = formattedLabel.text + (showValue ? labelSepChar + SPACE + value : BLANK);

    if (!showLabel || !formattedLabel.text) {
      text = showValue ? value : BLANK;
      sl.setStyle(style.label.normal);
      formattedLabel = sl.getSmartText(text);
    }
    node.config.nodeAttr = {
      x: props.x0,
      y: props.y0,
      width: Math.max(0, props.x1 - props.x0),
      height: Math.max(0, props.y1 - props.y0),
      ...nodeCosmetics
    };

    if (orientation === 'horizontal') {
      if (!rotateLabel) {
        if (labelPosition === START) {
          labelXPos = props.x0 - labelPadding;
          anchor = END;
        } else if (labelPosition === INSIDE) {
          labelXPos = Math.abs(props.x0 + props.x1) / 2;
          anchor = MIDDLE;
        } else {
          labelXPos = props.x1 + labelPadding;
          anchor = START;
        }
        labelYPos = Math.abs(props.y1 + props.y0) / 2;

        node.config.labelAttr = {
          x: labelXPos,
          y: labelYPos,
          text: text,
          transform: defaultTransform,
          'text-anchor': anchor,
          ...labelCosmetics
        };
      } else {
        if (labelPosition === START) {
          labelXPos = props.x0 - labelPadding - formattedLabel.height / 2;
        } else if (labelPosition === INSIDE) {
          labelXPos = Math.abs(props.x0 + props.x1) / 2;
        } else {
          labelXPos = props.x1 + labelPadding + formattedLabel.height / 2;
        }
        labelYPos = Math.abs(props.y1 + props.y0) / 2;

        node.config.labelAttr = {
          x: labelXPos,
          y: labelYPos,
          text: text,
          'text-anchor': MIDDLE,
          transform: getSuggestiveRotation(-90, labelXPos, labelYPos),
          ...labelCosmetics
        };
      }
    } else {
      if (!rotateLabel) {
        if (labelPosition === START) {
          labelYPos = props.y0 - labelPadding - formattedLabel.height / 2;
        } else if (labelPosition === INSIDE) {
          labelYPos = Math.abs(props.y0 + props.y1) / 2;
        } else {
          labelYPos = props.y1 + labelPadding + formattedLabel.height / 2;
        }
        anchor = MIDDLE;
        labelXPos = (props.x0 + props.x1) / 2;

        node.config.labelAttr = {
          x: labelXPos,
          y: labelYPos,
          text: text,
          transform: defaultTransform,
          'text-anchor': anchor,
          ...labelCosmetics
        };
      } else {
        if (labelPosition === START) {
          labelYPos = props.y0 - labelPadding;
          anchor = START;
        } else if (labelPosition === INSIDE) {
          labelYPos = Math.abs(props.y0 + props.y1) / 2;
          anchor = MIDDLE;
        } else {
          labelYPos = props.y1 + labelPadding;
          anchor = END;
        }
        labelXPos = Math.abs(props.x1 + props.x0) / 2;

        node.config.labelAttr = {
          x: labelXPos,
          y: labelYPos,
          text: text,
          'text-anchor': anchor,
          transform: getSuggestiveRotation(-90, labelXPos, labelYPos),
          ...labelCosmetics
        };
      }
    }
  }

  draw () {
    let node = this,
      chartConfig = node.getFromEnv('chartConfig'),
      { id, labelAttr, nodeAttr, textOutline } = node.config,
      tooltext = getTooltext(node.config, node, chartConfig);

    node.addGraphicalElement({
      el: 'rect',
      attr: nodeAttr,
      container: {
        id: 'sankey-node-group',
        label: 'nodeGroup',
        isParent: true
      },
      tooltext,
      component: node,
      id: id,
      label: 'node-rect'
    });

    labelAttr.text && node.addGraphicalElement({
      el: 'text',
      attr: labelAttr,
      container: {
        id: 'sankey-node-label-group',
        label: 'nodeLabelGroup',
        isParent: true
      },
      tooltext,
      component: node,
      id,
      css: {},
      outlineText: textOutline,
      label: 'node-label'
    });
  }
}

export default SankeyNode;
